// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__2IIcx","primary":"styles_primary__IdcC7","secondary":"styles_secondary__1-efI","prefix":"styles_prefix__2DBTd"};